export default __webpack_public_path__ + "static/DSC_0415-3fc0136437d74aaae758756025946036.jpg";